import React from 'react';
import {
  Box,
  Container,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Text,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const WebinarFAQ = ({ data }) => {
  // Safety check with proper defaults
  const componentData = data || {
    title: 'Frequently Asked Questions',
    faqs: []
  };

  // Handle both property naming conventions: q/a and question/answer
  const getQuestion = (faq) => faq.question || faq.q || 'Question not available';
  const getAnswer = (faq) => faq.answer || faq.a || 'Answer not available';

  return (
    <Box py={{ base: 16, md: 24 }} bg="brand.50">
      <Container maxW="container.md">
        <MotionBox
          textAlign="center"
          mb={12}
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Heading
            as="h2"
            fontSize={{ base: '2xl', md: '4xl' }}
            color="brand.700"
            fontFamily="heading"
          >
            {componentData.title}
          </Heading>
        </MotionBox>

        <MotionBox
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {componentData.faqs.length === 0 ? (
            <Text textAlign="center" color="gray.500">
              No FAQs available at the moment.
            </Text>
          ) : (
            <Accordion allowToggle>
              {componentData.faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  border="none"
                  bg="white"
                  mb={4}
                  borderRadius="xl"
                  overflow="hidden"
                  boxShadow="md"
                >
                  <AccordionButton
                    py={6}
                    px={6}
                    _hover={{ bg: 'brand.50' }}
                    _expanded={{ bg: 'accent.green', color: 'white' }}
                  >
                    <Box flex="1" textAlign="left">
                      <Text fontWeight="600" fontSize="lg">
                        {getQuestion(faq)}
                      </Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel py={4} px={6} bg="white">
                    <Text color="brand.600" lineHeight="1.6">
                      {getAnswer(faq)}
                    </Text>
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </MotionBox>
      </Container>
    </Box>
  );
};

export default WebinarFAQ;